import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, Card} from '@spothero/ui';
import PackageInfo from 'common/event-package-info/package-info';
import {PROPTYPE_EVENT_PACKAGE} from '@/proptypes/index';

const EventPackageDetails = ({eventPackage, onClick}) => {
    const {title, description, events} = eventPackage;

    return (
        <Card className="EventPackageDetails" margin={4}>
            <PackageInfo
                title={title}
                description={description}
                eventCount={events.length}
            />
            <Box textAlign="right">
                <Button variant="tertiary" onClick={onClick}>
                    View Package
                </Button>
            </Box>
        </Card>
    );
};

EventPackageDetails.propTypes = {
    eventPackage: PROPTYPE_EVENT_PACKAGE.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default EventPackageDetails;
